import apiPaths from '../api-paths';

export default {
  getImportReport({ id }) {
    return axios.get(`${ apiPaths.API }/files/${ id }/import-report`);
  },
};
